import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ContactusComponent} from "./contactus.component";

const routes: Routes = [{
  path:'contactus',
  component: ContactusComponent,
  data: {animation : 'contactus'}
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContactusRoutingModule { }
